<template>
  <b-modal id="cashTaxInvoiceRequestModal" title="현금 계산서 요청 (면세 계산서)" size="xl" :no-enforce-focus="true" @show="fn_load" @hidden="fn_reset">

    <div v-if="clinicData" class="modal_detail">

      <!-- 한의원 정보 -->
      <h3 class="section_title">한의원 정보</h3>
      <div class="table_list mb20">
        <table class="write">
          <colgroup>
            <col width="160">
            <col width="*">
            <col width="160">
            <col width="*">
          </colgroup>
          <tbody>
            <tr>
              <th><span>한의원명</span></th>
              <td>{{ clinicData.clinic_nm }}</td>
              <th><span>사업자번호</span></th>
              <td>{{ formatBizNumber(clinicData.clinic_business_num) }}</td>
            </tr>
            <tr>
              <th><span>조회기간</span></th>
              <td>{{ period }}</td>
              <th><span>총 발행예정 금액</span></th>
              <td class="fw_blue">{{ fn_comma_won(clinicData.wait_amt) }}원</td>
            </tr>
            <tr>
              <th><span>무통장 입금 건수</span></th>
              <td>{{ clinicData.vb_cnt }}건</td>
              <th><span>예치금 사용 건수</span></th>
              <td>{{ clinicData.deposit_cnt }}건</td>
            </tr>
            <tr>
              <th><span>총 무통장 입금액</span></th>
              <td>{{ fn_comma_won(clinicData.vb_amt) }}원</td>
              <th><span>총 예치금 사용금액</span></th>
              <td>{{ fn_comma_won(clinicData.deposit_amt) }}원</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 발송요청 대기내역 -->
      <h3 class="section_title mb10">발송요청 대기내역</h3>
      <div class="table_list">
        <div class="order_scroll_area">
          <table class="list">
            <colgroup>
              <col width="38">
              <col width="110">
              <col width="*">
              <col width="72">
              <col width="72">
              <col width="72">
              <col width="100">
              <col width="100">
              <col width="100">
              <col width="100">
            </colgroup>
            <thead>
              <tr>
                <th class="ac">
                  <div class="form_checkbox" style="min-width:auto;">
                    <input type="checkbox"
                           id="waitCheckAll"
                           :checked="isAllCurrentPageSelected"
                           :disabled="waitPagedList.length === 0"
                           @change="fn_toggle_all_current_page">
                    <label for="waitCheckAll"></label>
                  </div>
                </th>
                <th>주문코드</th>
                <th>처방명</th>
                <th>처방의</th>
                <th>환자명</th>
                <th class="ac">결제상태</th>
                <th class="ar">총주문금액</th>
                <th class="ar">무통장입금액</th>
                <th class="ar">예치금 사용금액</th>
                <th class="ar">합계금액</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="waitList.length === 0">
                <td colspan="10" class="ac"><span>발송 대기 내역이 없습니다.</span></td>
              </tr>
              <tr v-for="order in waitPagedList"
                  :key="order.order_code"
                  :class="order.payment_status === 'CANC' ? 'cancel_row' : (selectedMap[order.order_code] ? 'selected_row' : '')">
                <td class="ac">
                  <div class="form_checkbox" style="min-width:auto;">
                    <input type="checkbox"
                           :id="'waitChk_' + order.order_code"
                           :checked="!!selectedMap[order.order_code]"
                           @change="fn_toggle_select(order)">
                    <label :for="'waitChk_' + order.order_code"></label>
                  </div>
                </td>
                <td><span>{{ order.order_code }}</span></td>
                <td><span>{{ order.prescribe_nm }}</span></td>
                <td><span>{{ order.doctor_nm }}</span></td>
                <td><span>{{ order.patient_nm }}</span></td>
                <td class="ac">
                  <span class="status_badge" :class="getPaymentBadgeClass(order.payment_status)">
                    {{ order.payment_status_nm }}
                  </span>
                </td>
                <td class="ar"><span :class="{ color_red: order.payment_status === 'CANC' }">{{ fn_comma_won(order.total_price) }}</span></td>
                <td class="ar">
                  <span :class="{ color_red: order.payment_status === 'CANC' }">
                    {{ fn_comma_won(order.pay_price) }}
                  </span>
                </td>
                <td class="ar">
                  <span :class="{ color_red: order.payment_status === 'CANC' }">
                    {{ fn_comma_won(order.deposit_used_price) }}
                  </span>
                </td>
                <td class="ar">
                  <span :class="order.payment_status === 'CANC' ? 'color_red' : 'fw_blue'">
                    {{ fn_comma_won((order.real_amt || 0)) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 선택 합계 -->
        <div class="order_total">
          <div class="total_card" :class="{ total_card_dim: selectedCount === 0 }">
            <span class="total_card_label">선택</span>
            <span class="total_card_value">{{ selectedCount }}건</span>
          </div>
          <div class="total_card total_card_amt" :class="{ total_card_dim: selectedCount === 0 }">
            <span class="total_card_label">계산서 발행예정액</span>
            <strong class="total_card_value" :class="0 > selectedTotalAmt ? 'color_red' : 'color_blue'">
              {{ 0 > selectedTotalAmt ? '-' : '' }}{{ fn_comma_won(Math.abs(selectedTotalAmt)) }}원
            </strong>
          </div>
        </div>
        <!-- 페이징 -->
        <AdminPagination :pageInfo="waitPageInfo" @clickPage="fn_wait_move_page" v-show="waitPagingShow" />
      </div>

    </div>

    <div v-else class="ac pt20 pb20">
      <span>데이터를 불러오는 중입니다.</span>
    </div>

    <template #modal-footer>
      <b-button class="btn btn_md btn_darkblue"
                :disabled="selectedCount === 0"
                @click="fn_issue_invoice">
        세금계산서 발행<span v-if="selectedCount > 0"> ({{ selectedCount }}건)</span>
      </b-button>
      <b-button class="btn btn_md btn_brown" @click="$bvModal.hide('depositTaxInvoiceDetailModal')">확인</b-button>
    </template>

  </b-modal>
</template>

<script>
  import axios from 'axios'
  import commonUtil from '@/mixin/commonUtil'
  import AdminPagination from '@/components/AdminPagination.vue'

  export default {
    name: 'cashTaxInvoiceRequestModal',
    components: { AdminPagination },
    mixins: [commonUtil],
    props: {
      detailData: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        clinicData: null,
        period: '',
        // 발송대기
        waitList: [],
        waitPageInfo: { page: 1, pageSize: 10, totPage: 0 },
        waitPagingShow: false,
        selectedMap: {}
      }
    },
    computed: {
      waitPagedList() {
        return this.waitList
      },
      isAllCurrentPageSelected() {
        if (this.waitPagedList.length === 0) return false
        return this.waitPagedList.every(o => !!this.selectedMap[o.order_code])
      },
      selectedCount() {
        return Object.keys(this.selectedMap).length
      },
      selectedTotalAmt() {
        return Object.values(this.selectedMap).reduce((sum, o) => {
          const amt = o.real_amt || 0
          return sum + (o.payment_status === 'CANCEL' ? -amt : amt)
        }, 0)
      }
    },
    methods: {
      fn_load() {
        if (!this.detailData) return
        this.clinicData = { ...this.detailData.clinic }
        this.period     = `${this.detailData.startDate} ~ ${this.detailData.endDate}`

        // TODO: API 연동 - 발송대기 목록 조회
        axios.post('/api/admin/settlement/getWaitInvoiceList', {
          clinic_business_num: this.clinicData.clinic_business_num,
          pageInfo : this.waitPageInfo,
          startDate: this.detailData.startDate,
          endDate:   this.detailData.endDate
        }).then(res => {
          this.waitList = res.data.waitList
          this.waitPageInfo.totPage = res.data.totCnt
          this.waitPagingShow = res.data.totCnt > this.waitPageInfo.pageSize
        }).catch(err => console.log(err))


      },
      fn_reset() {
        this.clinicData         = null
        this.period             = ''
        this.waitList           = []
        this.waitPageInfo       = { page: 1, pageSize: 10, totPage: 0 }
        this.waitPagingShow     = false
        this.selectedMap        = {}
        this.completeList       = []
        this.completePageInfo   = { page: 1, pageSize: 10, totPage: 0 }
        this.completePagingShow = false
      },
      fn_toggle_select(order) {
        if (this.selectedMap[order.order_code]) {
          this.$delete(this.selectedMap, order.order_code)
        } else {
          this.$set(this.selectedMap, order.order_code, order)
        }
      },
      fn_toggle_all_current_page() {
        if (this.isAllCurrentPageSelected) {
          this.waitPagedList.forEach(o => this.$delete(this.selectedMap, o.order_code))
        } else {
          this.waitPagedList.forEach(o => this.$set(this.selectedMap, o.order_code, o))
        }
      },
      fn_wait_move_page(page) {
        this.waitPageInfo = { ...this.waitPageInfo, page }
        this.fn_load();
      },
      fn_issue_invoice() {
        if (this.selectedCount === 0) return

        // TODO: API 연동 - 세금계산서 발행
        // const orderCodes = Object.keys(this.selectedMap)
        // axios.post('/api/admin/settlement/issueInvoice', {
        //   clinicSeq: this.clinicData.clinic_seq,
        //   orderCodes
        // }).then(res => {
        //   alert('세금계산서 발행이 완료되었습니다.')
        //   this.selectedMap = {}
        //   this.fn_load()
        // }).catch(err => console.log(err))

        alert(`세금계산서 발행 예정 (${this.selectedCount}건 / ${this.fn_comma_won(this.selectedTotalAmt)}원)`)
      },
      getPaymentBadgeClass(status) {
        const map = { COMP: 'badge_blue', CANC: 'badge_red' }
        return map[status] || 'badge_gray'
      }
    }
  }
</script>

<style scoped>
  .section_title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #262939;
    border-left: 3px solid #262939;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .section_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .mb0  { margin-bottom: 0; }
  .mb10 { margin-bottom: 10px; }
  .mb20 { margin-bottom: 20px; }
  .pt20 { padding-top: 20px; }
  .pb20 { padding-bottom: 20px; }
  .ar   { text-align: right; }
  .ac   { text-align: center; }

  .fw_blue   { color: #2b6cb0; font-weight: 700; }
  .fw_green  { color: #276749; font-weight: 700; }
  .color_red { color: #c53030; font-weight: 600; }

  /* 한의원 정보 테이블 셀 패딩 축소 */
  .modal_detail .table_list table.write th,
  .modal_detail .table_list table.write td {
    padding: 6px 10px;
  }

  /* 스크롤 영역: 10행 + 헤더 표시 */
  .order_scroll_area {
    max-height: 408px;
    overflow-y: auto;
    overflow-x: auto;
  }
  .order_scroll_area table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f5f6fa;
  }

  /* 셀 합침 영역 */
  .merge_cell {
    background: #f7fafc;
    vertical-align: middle;
  }
  .invoice_no {
    font-size: 1.2rem;
    color: #4a5568;
    word-break: break-all;
  }

  /* 선택된 행 */
  .selected_row { background: #ebf4ff; }
  /* 취소 행 */
  .cancel_row { background: #fff5f5; }

  /* 합계 카드 영역 */
  .order_total {
    display: flex;
    gap: 8px;
    padding: 8px 0 0;
  }
  .total_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 10px 20px;
    background: #f0f4ff;
    border: 1px solid #c7d7f5;
    border-radius: 6px;
    min-width: 100px;
    transition: opacity 0.2s;
  }
  .total_card_amt {
    flex: 1;
  }
  .total_card_dim {
    opacity: 0.4;
  }
  .total_card_label {
    font-size: 1.2rem;
    color: #718096;
    font-weight: 600;
    white-space: nowrap;
  }
  .total_card_value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #262939;
    white-space: nowrap;
  }
  .color_blue { color: #2b6cb0; }

  /* 결제상태 뱃지 */
  .status_badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 1.2rem;
    font-weight: 600;
    white-space: nowrap;
  }
  .badge_blue { background: #ebf4ff; color: #2b6cb0; }
  .badge_red  { background: #c53030; color: #fff; }
  .badge_gray { background: #f7fafc; color: #718096; border: 1px solid #e2e8f0; }

  /* 전역 .pagination margin 축소 */
  ::v-deep .pagination { margin: 4px 0 0; }

  /* 모달 바디 하단 패딩 축소 */
  ::v-deep .modal-body { padding-bottom: 8px; }
</style>